module.exports = __webpack_public_path__ + "static/job_offer01-3e0daf826d85fe6caa2a4e721087b6bf.jpg";